import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

export interface CatchwordProps {
  children?: ReactNode
}

const Wrapper = styled.div`
  ${({
    theme: {
      colors: { textBrand },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadingCSS },
        },
      },
      utils: { ellipsis },
    },
  }) => css`
    ${ellipsis('100%', 2)};
    ${small1SubheadingCSS};
    line-height: 1.5;
    color: ${textBrand};
  `}
`

const StyledCatchword = styled.div`
  ${({
    theme: {
      spacing: { spacing2, spacing4, spacing12 },
      colors: { fillDefault },
    },
  }) => css`
    background-color: ${fillDefault};
    padding: ${spacing2} ${spacing4};

    display: inline;
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;

    word-break: break-word;
    box-shadow: ${spacing12} 0 0 ${fillDefault};
  `}
`

const Catchword: FunctionComponent<CatchwordProps> = ({ children }) => {
  return (
    <Wrapper>
      <StyledCatchword>{children}</StyledCatchword>
    </Wrapper>
  )
}

export default Catchword
